import { Box, Button, Checkbox, Divider, Grid, IconButton, InputAdornment, Typography } from '@mui/material'
import { useStyles } from './styles'
import BaseModal from '../../../../../../components/modal/baseModal'
import { icons } from '../../../../../../utils/icons'
import { PropsModalUserGroup } from './types'
import React, { useEffect, useRef, useState } from 'react'
import { CustomPaper } from '../../../../../../components/CustomPaper'
import { useTranslation } from 'react-i18next'
import { Virtuoso } from 'react-virtuoso'
import { DinamicForm } from '../../../../../../components/dinamicForm'
import { CustomTable } from '../../../../../../components'
import { InputModel } from '../../../../../../utils/types'
import { useFilter } from '../../../../../../hooks/filter'
import { RowItemGroup } from '../../../../../../service/userGroup/response'
import { formatUserGroupListWithOutPagination } from '../../../../../../service/userGroup/format'
import { userGroupServiceFetch } from '../../../../../../utils/constants/callService'
import { returnQueryWithPagination } from '../../../../../../utils/methods/returnQuery'



export const UserGroupAdd = ({ open, title, buttonText, cancelText, next, back, sx, groupsAlreadySelected }: PropsModalUserGroup) => {

    const styles = useStyles()
    const { t } = useTranslation()

    const [groupsSelected, setGroupsSelected] = useState<{ id: number; name: string; }[]>(groupsAlreadySelected)
    const [selectsWithData, setSelectsWithData] = useState<{ id: number, name: string }[]>([]);
    const [tableLoading, setTableLoading] = useState(false)
    const refTime = useRef<NodeJS.Timeout | null>(null)
    const filter = useFilter({ formatFilter: {} })
    const { cleanFilter, errors, filterData, onChange, query } = filter
    const [row, setRow] = useState<RowItemGroup[]>([])
    const [listUserGroup, setListUserGroup] = useState<Record<string, boolean>>({})

    const deleteGroup = (id: number) => {
        setGroupsSelected(prev => prev.filter(group => group.id !== id));
    };

    const input = {
        search: {
            label: 'userGroup.filter.search',
            translate: true,
            name: 'search',
            rest: {
                type: 'alphaNumeric',
            },
            value: null,
            wrapChildren: ({ children, id }) => {
                return React.cloneElement(children, {
                    id,
                    InputProps: {
                        ...(children.props.InputProps ?? {}),
                        endAdornment: (
                            <InputAdornment position="end">
                                {icons('search')}
                            </InputAdornment>
                        ),
                    },
                });
            }
        }
    } as { [x: string]: InputModel }

    const column = [
        {
            id: 'resendGroup',
            label: '',
            //headerCell: styles?.header,
            column: () => (
                <Checkbox
                    onChange={(e, checked) => {
                        e.stopPropagation();
                        handleSelects('0', checked)
                    }}
                    checked={!!listUserGroup?.['0']}
                />
            ),
            renderCell: (params: any) => (
                <Checkbox
                    checked={!!listUserGroup[params?.row?.id]}
                    onChange={(e, checked) => {
                        e.stopPropagation();
                        handleSelects(String(params?.row?.id), checked, params?.row?.name)
                    }}
                />
            )
        },
        {
            id: 'name',
            label: t('userGroup.columns.groupName'),
            headerCell: styles?.headerTable,
            sortable: true
        },
        {
            id: 'internalUsers',
            label: t('userGroup.columns.numberOfInternalUsers'),
            headerCell: styles?.headerTable,
            sortable: true
        },
        {
            id: 'externalUsers',
            label: t('userGroup.columns.numberOfExternalUsers'),
            headerCell: styles?.headerTable,
            sortable: true
        }
    ]

    const handleSelects = (id: string, value: boolean, name?: string) => {

        if (id == '0') {
            if (!!row?.length) {
                setListUserGroup(prev => {
                    const updated = { ...prev };

                    for (const item of row) {
                        updated[item.id] = value;
                    }

                    updated[0] = value;

                    return updated;
                });

                if (!!value) {
                    setSelectsWithData(prev => {
                        const existentes = new Set(prev.map(i => i.id));

                        const nuevos = row
                            .map(item => ({ id: item.id, name: item.name }))
                            .filter(item => !existentes.has(item.id));

                        return [...prev, ...nuevos];
                    });
                } else {
                    setSelectsWithData([]);
                }
            }
        } else {
            const newList = { ...listUserGroup, [id]: value }
            setListUserGroup(newList)

            if (!!value) {
                validateAllUsersAreSelectedToGroup({ list: row, listUsers: newList })
                setSelectsWithData(prev => {
                    const yaExiste = prev.some(item => item.id === Number(id));
                    if (yaExiste) return prev;

                    return [...prev, { id: Number(id), name: name ?? '' }];
                });
            } else {
                setListUserGroup(prev => ({ ...prev, 0: false }))
                setSelectsWithData(prev =>
                    prev.filter(item => item.id !== Number(id))
                );
            }
        }
    };

    const validateAllUsersAreSelectedToGroup = ({ list, listUsers }: { list: any[]; listUsers: Record<string, boolean> }) => {
        const areThereAnyUserUnSelected = !!list?.length ? !!list?.some(item => !listUsers[item.id]) : true

        setListUserGroup(prev => ({ ...prev, 0: !areThereAnyUserUnSelected }))
    }

    const getGroupList = async () => {
        setTableLoading(true)
        const response = await userGroupServiceFetch.getListGroupsWithOutPagination({ query: returnQueryWithPagination({ ...filter.query, filter: filter.query.filter?.replaceAll('+', '%2B') }, {}) })
        const { row } = formatUserGroupListWithOutPagination({ response })

        if (!response?.errors) {
            setRow(row)
            validateAllUsersAreSelectedToGroup({ list: row, listUsers: listUserGroup })
        }

        setTableLoading(false)
    }

    const handleAddGroups = () => {
        setGroupsSelected(prev => {
            const ids = new Set(prev.map(item => item.id));

            const nuevos = selectsWithData.filter(item => !ids.has(item.id));

            return [...prev, ...nuevos];
        });

        setSelectsWithData([]);
        setListUserGroup({})
    };

    useEffect(() => {
        if (refTime.current) { clearTimeout(refTime.current) }

        refTime.current = setTimeout(() => {
            getGroupList()
        }, 300)
    }, [query.all])

    useEffect(() => {
        setGroupsSelected(groupsAlreadySelected);
        cleanFilter()
        setSelectsWithData([]);
        setListUserGroup({})
    }, [open]);

    return (
        <BaseModal open={open} sx={{ ...styles.baseModal, ...(sx ?? {}) } as object}>

            <Box sx={styles.containerSuccess}>

                <Box sx={styles.closeSuccess}>
                    <IconButton onClick={() => { back() }} >
                        {icons('simple-close')}
                    </IconButton>
                </Box>

                <Box sx={styles.containerBody}>
                    <Typography sx={styles.title}>{title}</Typography>

                    <Grid container spacing={3}>
                        <Grid item xs={8}>
                            <Box sx={styles.containerTable}>
                                <DinamicForm input={Object.values(input)} onChange={onChange} errors={errors} values={filterData} />
                                <CustomPaper elevation={3} sx={styles.paper} className='mt'>
                                    <Box sx={styles.containerTitle}>
                                        <Typography fontWeight={'bold'} variant='subtitle_grey'>{t('userGroup.titles.userList')}</Typography>

                                        <Button disabled={!selectsWithData.length} variant="contained" onClick={handleAddGroups}>{t('general.add')}</Button>
                                    </Box>

                                    <CustomTable
                                        //defaulPagination={20}
                                        name="Informe General"
                                        dontRefresh
                                        column={column}
                                        row={row ?? []}
                                        selected={-1}
                                        loader={tableLoading}
                                    />
                                </CustomPaper>
                            </Box>
                        </Grid>

                        <Grid item xs={4}>
                            <CustomPaper elevation={3} sx={styles.paper} className='left'>
                                <Typography fontWeight={'bold'} variant='subtitle_grey'>{t('Questionarie.selectedGroups')}</Typography>

                                <Virtuoso
                                    style={styles.list as any}
                                    totalCount={groupsSelected?.length}
                                    components={{
                                        EmptyPlaceholder: () => (
                                            <Box>
                                                <Typography sx={styles.empty}>
                                                    {t('general.messages.emptyTable')}
                                                </Typography>

                                                <Divider sx={styles.divider} />
                                            </Box>
                                        ),
                                    }}
                                    itemContent={(index) => {
                                        const user = groupsSelected?.[index]
                                        return (
                                            <Box key={user.id} sx={[styles.userContainer, styles.userBox]}>
                                                {icons('user')}
                                                <Box sx={styles.containerText}>
                                                    <Typography sx={styles.name}>{user.name}</Typography>
                                                </Box>

                                                <IconButton className="closeIcon" onClick={() => { deleteGroup(user.id) }} sx={styles.buttonClose}>{icons('simple-close')}</IconButton>
                                            </Box>
                                        )
                                    }}
                                />
                            </CustomPaper>
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={styles.buttonsContainer}>
                    <Button className='back' onClick={() => { back() }} >
                        {cancelText}
                    </Button>


                    <Button className='next' variant="contained" disabled={!groupsSelected.length} onClick={() => { next({ list: groupsSelected }) }} >
                        {buttonText}
                    </Button>
                </Box>

            </Box>
        </BaseModal>
    )
}

